import {useState} from "react";
import submitForm from "../../models/forms";
import PropTypes from "prop-types";


export default function MainForm(props) {

    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [website, setWebsite] = useState('');
    const [didSubmit, setDidSubmit] = useState(false);

    const [invalidField, setInvalidField] = useState(false);

    return (
        <div className="space-y-2 mt-0">
            <div className="sm:col-span-3">
                <label htmlFor="first-name"
                       className="block text-sm/6 font-medium text-white">
                    Full name
                </label>
                <div className="">
                    <input
                        id="full-name"
                        name="full-name"
                        type="text"
                        autoComplete="name"
                        disabled={didSubmit}
                        value={fullName}
                        onChange={(e) => {setFullName(e.target.value)}}
                        className={`${(invalidField && !Boolean(fullName)) ? "bg-red-300" : "bg-white/5"} block w-full rounded-md  px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6`}
                    />
                </div>
            </div>
            <div className="sm:col-span-3">
                <label htmlFor="first-name"
                       className="block text-sm/6 font-medium text-white">
                    Email
                </label>
                <div className="">
                    <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        disabled={didSubmit}
                        value={email}
                        onChange={(e) => {setEmail(e.target.value)}}
                        className={`${(invalidField && !Boolean(email)) ? "bg-red-300" : "bg-white/5"} block w-full rounded-md  px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6`}
                    />
                </div>
            </div>
            <div className="sm:col-span-3">
                <label htmlFor="first-name"
                       className="block text-sm/6 font-medium text-white">
                    Website
                </label>
                <div className="">
                    <input
                        id="website"
                        name="website"
                        type="url"
                        disabled={didSubmit}
                        value={website}
                        onChange={(e) => {setWebsite(e.target.value)}}
                        className={`${(invalidField && !Boolean(website)) ? "bg-red-300" : "bg-white/5"} block w-full rounded-md  px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6`}
                    />
                </div>
            </div>
            <div className="flex justify-end">
                <button
                    type="button"
                    disabled={didSubmit}
                    className={`${didSubmit ? "bg-gray-600" : "bg-red-600 hover:bg-indigo-500"} mt-4 w-full rounded-full px-4 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                    onClick={() => {
                        submitForm(props.formType || "proposal_request_main_hero", {
                            full_name: fullName,
                            email: email,
                            website: website,
                        })
                        if (!email) {
                            setInvalidField(true)
                            return
                        }
                        setDidSubmit(true)
                    }}
                >
                    { didSubmit ? "Submitted!" : "Submit Proposal Request" }
                </button>
            </div>
        </div>
    )
}

MainForm.propTypes = {
    formType: PropTypes.string,
}